<div class="login-app">
  <div class="login-container relative">
    <button
      type="button"
      class="login-darkmode-toggle"
      (click)="appearanceService.toggleDarkMode()"
      [hidden]="!appearanceService.canToggleDarkMode"
    >
      @if (appearanceService.isDarkMode()) {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="18"
          height="18"
        >
          <path
            d="M12 2.25a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM7.5 12a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM18.894 6.166a.75.75 0 0 0-1.06-1.06l-1.591 1.59a.75.75 0 1 0 1.06 1.061l1.591-1.59ZM21.75 12a.75.75 0 0 1-.75.75h-2.25a.75.75 0 0 1 0-1.5H21a.75.75 0 0 1 .75.75ZM17.834 18.894a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 1 0-1.061 1.06l1.59 1.591ZM12 18a.75.75 0 0 1 .75.75V21a.75.75 0 0 1-1.5 0v-2.25A.75.75 0 0 1 12 18ZM7.758 17.303a.75.75 0 0 0-1.061-1.06l-1.591 1.59a.75.75 0 0 0 1.06 1.061l1.591-1.59ZM6 12a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h2.25A.75.75 0 0 1 6 12ZM6.697 7.757a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 0 0-1.061 1.06l1.59 1.591Z"
          />
        </svg>
      } @else {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="18"
          height="18"
        >
          <path
            fill-rule="evenodd"
            d="M9.528 1.718a.75.75 0 0 1 .162.819A8.97 8.97 0 0 0 9 6a9 9 0 0 0 9 9 8.97 8.97 0 0 0 3.463-.69.75.75 0 0 1 .981.98 10.503 10.503 0 0 1-9.694 6.46c-5.799 0-10.5-4.7-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 0 1 .818.162Z"
            clip-rule="evenodd"
          />
        </svg>
      }
    </button>
    <div class="login-company-branding">
      @if (brandingSrc()) {
        <div class="login-branding-image flex items-center justify-center mb-4">
          <img
            [src]="brandingSrc()"
            alt="Logo"
            class="login-branding-image__img"
            (error)="onBrandingError()"
          />
          <ng-container [ngTemplateOutlet]="envBadge" />
        </div>
      } @else if (scanLogo) {
        <div class="login-company-branding-logo">
          <span class="login-logo-scan" [class.is-scanning]="scanning()">
            <span
              class="login-logo-scan__bars"
              aria-hidden="true"
              (animationend)="onScanEnd()"
            >
              @for (width of scanBarWidths(); track $index) {
                <span class="login-logo-scan__bar" [style.width.px]="width"></span>
              }
            </span>
            <span class="login-logo-scan__mark">
              <svg
                viewBox="0 0 450 405"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
              >
                <path
                  d="M303.75 0C214.281 0 141.75 75.6293 141.75 168.92V236.488C150.343 236.488 158.584 232.929 164.66 226.593C170.736 220.257 174.15 211.664 174.15 202.704V168.92C174.15 94.2855 232.173 33.784 303.75 33.784H450V0H303.75Z"
                  fill="var(--colorPrimary)"
                />
                <path
                  d="M303.75 67.568C250.069 67.568 206.55 112.947 206.55 168.92V202.704C206.55 220.624 199.723 237.81 187.571 250.482C175.418 263.153 158.936 270.272 141.75 270.272H0V337.84H141.75C213.327 337.84 271.35 277.339 271.35 202.704V168.92C271.35 159.96 274.764 151.367 280.84 145.031C286.916 138.695 295.157 135.136 303.75 135.136L450 135.174V67.4789L303.75 67.568Z"
                  fill="var(--colorPrimary)"
                />
                <path
                  d="M303.75 193.676L303.034 226.053C300.847 303.943 240.957 372.45 157.954 370.39H1.34998V404.174H157.95C277.348 401.701 330.75 316.725 333.085 230.229V160.314C315.193 160.319 303.75 175.02 303.75 193.676Z"
                  fill="var(--colorPrimary)"
                />
              </svg>
            </span>
            <span class="login-logo-scan__line" aria-hidden="true"></span>
          </span>
          <span class="login-brand-layer" aria-hidden="true" data-testid="login-brand-layer"></span>
          <ng-container [ngTemplateOutlet]="envBadge" />
        </div>
      } @else {
        <div
          class="login-company-branding-logo"
          style="cursor: pointer"
          (click)="spinLogo()"
        >
          <ng-container [ngTemplateOutlet]="envBadge" />
          <svg
            viewBox="0 0 450 405"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            [class.logo-spin]="logoSpinning()"
            [style.--rotation]="rotationDegrees() + 'deg'"
            (animationend)="onLogoAnimationEnd()"
          >
            <path
              d="M303.75 0C214.281 0 141.75 75.6293 141.75 168.92V236.488C150.343 236.488 158.584 232.929 164.66 226.593C170.736 220.257 174.15 211.664 174.15 202.704V168.92C174.15 94.2855 232.173 33.784 303.75 33.784H450V0H303.75Z"
              fill="var(--colorPrimary)"
            />
            <mask
              id="login-mask0"
              style="mask-type: luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="67"
              width="450"
              height="271"
            >
              <path
                d="M303.75 67.568C250.069 67.568 206.55 112.947 206.55 168.92V202.704C206.55 220.624 199.723 237.81 187.571 250.482C175.418 263.153 158.936 270.272 141.75 270.272H0V337.84H141.75C213.327 337.84 271.35 277.339 271.35 202.704V168.92C271.35 159.96 274.764 151.367 280.84 145.031C286.916 138.695 295.157 135.136 303.75 135.136L450 135.174V67.4789L303.75 67.568Z"
                fill="white"
              />
            </mask>
            <g mask="url(#login-mask0)">
              <g filter="url(#login-filter0)">
                <mask
                  id="login-mask1"
                  style="mask-type: luminance"
                  maskUnits="userSpaceOnUse"
                  x="-3"
                  y="65"
                  width="456"
                  height="276"
                >
                  <path d="M452.25 65.1328H-2.25V340.186H452.25V65.1328Z" fill="white" />
                </mask>
                <g mask="url(#login-mask1)">
                  <path
                    d="M-2.35803 65.1282H452.322V340.355H-2.35803V65.1282Z"
                    fill="var(--colorPrimary)"
                  />
                </g>
              </g>
            </g>
            <path
              d="M303.75 193.676L303.034 226.053C300.847 303.943 240.957 372.45 157.954 370.39H1.34998V404.174H157.95C277.348 401.701 330.75 316.725 333.085 230.229V160.314C315.193 160.319 303.75 175.02 303.75 193.676Z"
              fill="var(--colorPrimary)"
            />
            <defs>
              <filter
                id="login-filter0"
                x="-6.25"
                y="65.1328"
                width="462.5"
                height="283.053"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
              <radialGradient
                id="login-gradient0"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(238.567 203.016) rotate(90.9656) scale(249.829 249.829)"
              >
                <stop offset="0.41" stop-color="var(--colorPrimary400)" />
                <stop offset="0.89" stop-color="var(--colorPrimary800)" />
              </radialGradient>
            </defs>
          </svg>
          <span class="login-brand-layer" aria-hidden="true" data-testid="login-brand-layer"></span>
        </div>
      }
    </div>
    <h1 class="text-3xl font-extrabold text-center">
      {{ appName() }}
    </h1>
    @if (isReturningUser) {
      <p class="text-center text-light font-medium mt-2! mb-8!">Willkommen zurück!</p>
    } @else {
      <p class="text-center text-light font-medium mt-2! mb-8!">
        Melden Sie sich an, um fortzufahren.
      </p>
    }
    <router-outlet />
  </div>
</div>
<div class="soft-app-info">
  @if (!isMobile()) {
    <div class="public-shell-footer-brand">
      @if (brandingSrc()) {
        <div
          class="login-company-branding-logo mb-4"
          style="cursor: pointer"
          (click)="spinLogo()"
        >
          <svg
            viewBox="0 0 450 405"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            [class.logo-spin]="logoSpinning()"
            [style.--rotation]="rotationDegrees() + 'deg'"
            (animationend)="onLogoAnimationEnd()"
          >
            <path
              d="M303.75 0C214.281 0 141.75 75.6293 141.75 168.92V236.488C150.343 236.488 158.584 232.929 164.66 226.593C170.736 220.257 174.15 211.664 174.15 202.704V168.92C174.15 94.2855 232.173 33.784 303.75 33.784H450V0H303.75Z"
              fill="var(--colorPrimary)"
            />
            <mask
              id="footer-mask0"
              style="mask-type: luminance"
              maskUnits="userSpaceOnUse"
              x="0"
              y="67"
              width="450"
              height="271"
            >
              <path
                d="M303.75 67.568C250.069 67.568 206.55 112.947 206.55 168.92V202.704C206.55 220.624 199.723 237.81 187.571 250.482C175.418 263.153 158.936 270.272 141.75 270.272H0V337.84H141.75C213.327 337.84 271.35 277.339 271.35 202.704V168.92C271.35 159.96 274.764 151.367 280.84 145.031C286.916 138.695 295.157 135.136 303.75 135.136L450 135.174V67.4789L303.75 67.568Z"
                fill="white"
              />
            </mask>
            <g mask="url(#footer-mask0)">
              <path
                d="M-2.35803 65.1282H452.322V340.355H-2.35803V65.1282Z"
                fill="var(--colorPrimary)"
              />
            </g>
            <path
              d="M303.75 193.676L303.034 226.053C300.847 303.943 240.957 372.45 157.954 370.39H1.34998V404.174H157.95C277.348 401.701 330.75 316.725 333.085 230.229V160.314C315.193 160.319 303.75 175.02 303.75 193.676Z"
              fill="var(--colorPrimary)"
            />
          </svg>
        </div>
      }
    </div>
  }
  <div class="public-shell-footer-meta">
    <img
      src="assets/softapps-text-logo.svg"
      alt="SoftApps"
      class="public-shell-footer-logo"
    />
    <span class="public-shell-footer-sep">&middot;</span>
    <span>&copy; Softline IT GmbH 1980-{{ year }}</span>
    <span class="public-shell-footer-sep">&middot;</span>
    <span>{{ version() }}</span>
  </div>
</div>

<ng-template #envBadge>
  @if (logoBadge) {
    <span
      class="login-logo-badge"
      [class.is-test]="logoBadge === 'test'"
      [class.is-demo]="logoBadge === 'demo'"
      data-testid="login-env-badge"
    >
      {{ logoBadge }}
    </span>
  }
</ng-template>
